/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InformacionArticuloDto } from '../../models/informacion-articulo-dto';

export interface ArticulosControllerObtenerArticulosPorId$Params {

/**
 * Uuid del artículo para obtener información adicional
 */
  uuidArticulo: string;
}

export function articulosControllerObtenerArticulosPorId(http: HttpClient, rootUrl: string, params: ArticulosControllerObtenerArticulosPorId$Params, context?: HttpContext): Observable<StrictHttpResponse<InformacionArticuloDto>> {
  const rb = new RequestBuilder(rootUrl, articulosControllerObtenerArticulosPorId.PATH, 'get');
  if (params) {
    rb.path('uuidArticulo', params.uuidArticulo, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InformacionArticuloDto>;
    })
  );
}

articulosControllerObtenerArticulosPorId.PATH = '/api/articulos/obtener-articulos/{uuidArticulo}';
